<h4 translate="services.wifi.title"></h4>

<div class="btn-bar">
  @if (!!assignedWifi && assignedWifi.subscriptionCount === 0) {
    <button class="btn btn-primary"
      (click)="openWifiModal()"
      translate="services.wifi.action.update">
    </button>
  }
  @if (!assignedWifi) {
    <button class="btn btn-primary"
      (click)="openWifiModal()"
      translate="services.wifi.action.add">
    </button>
  }
</div>

<div class="table-responsive">
  <table class="table table-striped"
    [attr.aria-label]="'common.wifiNetworks' | translate">
    <thead>
      <tr>
        <th scope="col" style="min-width: 40%" translate="services.wifi.name"></th>
        <th scope="col" style="min-width: 40%" translate="services.wifi.ssid"></th>
        <th scope="col" style="min-width: 20%" translate="services.wifi.subscriptionCount"></th>
      </tr>
    </thead>

    <tbody>
      @if (!assignedWifi) {
        <tr>
          <td>-</td>
          <td>-</td>
          <td>-</td>
        </tr>
      } @else {
        <tr>
          <td>{{ getWifiName(assignedWifi) }}</td>
          <td>{{ assignedWifi.ssid }}</td>
          <td>{{ assignedWifi.subscriptionCount }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
